import { render } from "./BaseButton.vue?vue&type=template&id=cbeaf8fc&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=cbeaf8fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cbeaf8fc"

export default script